import React, { useState } from 'react';
import { motion } from 'framer-motion';
import {
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaGithub,
  FaLinkedin
} from 'react-icons/fa';
import '../css/Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Form submitted! Connect EmailJS or backend next.');
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <section id="contact" className="contact-section">
      <motion.div
        className="section-heading-wrap"
        initial={{ opacity: 0, y: 35 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
      >
        <span className="section-tag">Let’s Connect</span>
        <h1>Contact</h1>
        <p>
          Open to full-stack roles, AI product opportunities, collaborations, and OZ Mechanic growth.
        </p>
      </motion.div>

      <div className="contact-modern-wrap">
        <motion.div
          className="contact-info-modern"
          initial={{ opacity: 0, x: -45 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.65 }}
        >
          <h2>Get in touch</h2>
          <p>
            Whether it’s a software opportunity, product collaboration, or automotive-tech idea,
            feel free to reach out.
          </p>

          <div className="contact-info-list">
            <a href="mailto:honourkorkmaz@gmail.com">
              <FaEnvelope /> honourkorkmaz@gmail.com
            </a>
            <a href="tel:+16476073838">
              <FaPhone /> 647-607-3838
            </a>
            <span>
              <FaMapMarkerAlt /> Toronto, Canada
            </span>
            <a href="https://github.com/ozXoz" target="_blank" rel="noreferrer">
              <FaGithub /> github.com/ozXoz
            </a>
            <a href="https://linkedin.com/in/onur-korkmaz" target="_blank" rel="noreferrer">
              <FaLinkedin /> linkedin.com/in/onur-korkmaz
            </a>
          </div>
        </motion.div>

        <motion.form
          className="contact-form-modern"
          onSubmit={handleSubmit}
          initial={{ opacity: 0, x: 45 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.65 }}
        >
          <div className="modern-form-group">
            <label>Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="modern-form-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="modern-form-group">
            <label>Message</label>
            <textarea
              name="message"
              rows="6"
              value={formData.message}
              onChange={handleChange}
              required
            />
          </div>

          <button type="submit" className="modern-submit-btn">
            Send Message
          </button>
        </motion.form>
      </div>
    </section>
  );
};

export default Contact;
